import { createContext, type ReactNode, useContext } from "react";

import { Stack, styled } from "~/common/mui";
import EditButton from "~/features/configurator/common/components/ConfigurationSummaryComponent/EditButton/EditButton";

const Root = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
}));

const Title = styled("p")(({ theme }) => ({
  ...theme.typography.bodyMedium,
  color: theme.palette.text.secondary,
  textDecoration: "underline",
  margin: 0,
  marginBottom: theme.spacing(-2),
}));

interface Props {
  stepNumber: number;
  name: ReactNode;
  children?: ReactNode;
  showEdit?: boolean;
}

export const ShaftSummaryStepFrame = ({ stepNumber, name, children, showEdit = true }: Props) => {
  const onStepChange = useContext(OnStepChangeContext);
  return (
    <Root>
      <Title>
        <span className={"f-pre"}>{stepNumber}. </span>
        <span>{name}</span>
      </Title>
      {children && <div>{children}</div>}
      {showEdit && <EditButton className={""} index={stepNumber - 1} onStepChange={onStepChange} />}
    </Root>
  );
};

type Fn = () => void;
const OnStepChangeContext = createContext<Fn | undefined>(undefined);
export const OnStepChangeContextProvider = OnStepChangeContext.Provider;
